module.exports = __webpack_public_path__ + "img/mohammed-fazil-shoe.a4a9654.jpg";